import { PriceBreakDownItemType } from "~/generated/graphql";
import useGetCartPriceBreakDownItems from "~/clientState/hooks/useGetCartPriceBreakDownItems";
import useHasCustomerSelectedPrimePrice from "~/clientState/hooks/useHasCustomerSelectedPrimePrice";
import useHasFlightDiscountSelectedBySessionStorage from "~/clientState/hooks/useHasFlightDiscountSelectedBySessionStorage";
import useHasDynpackCustomerSelectedPrimePrice from "~/clientState/hooks/useHasDynpackCustomerSelectedPrimePrice";
import useFeeSelectedFromUrl from "~/clientState/hooks/useFeeSelectedFromUrl";
import { useFunnelFromUrl } from "~/clientState/hooks/useFunnelFromUrl";

const DEFAULT_PRIME_PRICE_SELECTED = true;

export const usePrimePriceSelectedInResults = (
  isHSAFeeSelectedFromUrl = false,
): boolean => {
  const { cartPriceBreakDownItems } = useGetCartPriceBreakDownItems();
  const feeSelectedFromUrl = useFeeSelectedFromUrl();

  const { isHSAFunnel, isDynpackFunnel } = useFunnelFromUrl();
  const hasHSADiscountSelected = useHasCustomerSelectedPrimePrice(
    cartPriceBreakDownItems,
    PriceBreakDownItemType.Accommodation,
  );

  const hasDynpackDiscountSelected = useHasDynpackCustomerSelectedPrimePrice();

  const hasFlightDiscountSelected =
    useHasFlightDiscountSelectedBySessionStorage();

  if (isHSAFunnel) {
    if (isHSAFeeSelectedFromUrl) return feeSelectedFromUrl;
    return hasHSADiscountSelected;
  }

  if (isDynpackFunnel) {
    return hasDynpackDiscountSelected;
  }

  if (hasFlightDiscountSelected !== undefined) {
    return hasFlightDiscountSelected;
  }

  return DEFAULT_PRIME_PRICE_SELECTED;
};
